import { render, staticRenderFns } from "./OrderResult.vue?vue&type=template&id=039303b1&scoped=true&"
import script from "./OrderResult.vue?vue&type=script&lang=js&"
export * from "./OrderResult.vue?vue&type=script&lang=js&"
import style0 from "./OrderResult.vue?vue&type=style&index=0&id=039303b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039303b1",
  null
  
)

export default component.exports